import React, { Component } from 'react';
import Outbox from './Outbox.js';

export default class OutboxAll extends Component {
  render() {
    return (
      <Outbox type='all'/>
    );
  }
}
